import { render, staticRenderFns } from "./Claim.vue?vue&type=template&id=7d09a0c0&scoped=true&"
import script from "./Claim.vue?vue&type=script&lang=js&"
export * from "./Claim.vue?vue&type=script&lang=js&"
import style0 from "./Claim.vue?vue&type=style&index=0&id=7d09a0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d09a0c0",
  null
  
)

export default component.exports